import { Middleware } from '@reduxjs/toolkit'
import { QuickTradeData, removeQuickOrderData, setQuickOrderData } from '../reducer/orders.reducer'
import { hideQuickTradePaperInstant, showQuickTradePaperInstant } from '../components/quickTradeWindow/quickTradeVisibility'

export const quickTradeVisibilityMiddleware: Middleware = () => (next) => (action) => {
    if (setQuickOrderData.match(action)) {
        const payload = action.payload as Partial<QuickTradeData>
        if (payload.openDialog === true) {
            showQuickTradePaperInstant()
        } else if (payload.openDialog === false) {
            hideQuickTradePaperInstant()
        }
    } else if (removeQuickOrderData.match(action)) {
        hideQuickTradePaperInstant()
    }
    return next(action)
}
